export const Constants = {
  approximate_loc: 'Localização aproximada — mova o pin para ajustar',
  search_error: 'Localização não encontrada, altere o endereço ou mova o pin.',
  movePin: 'Mova o pin caso a localização esteja incorreta',
  lat: 'Latitude:',
  lng: 'Longitude:',
  locPending: 'Localização pendente de confirmação',
};
